import React from 'react';
import * as d3 from 'd3';
import Transition from 'join-transition';

import Nodes from './Nodes';
import Links from './Links';

import './style.css';

export default class Flows extends React.Component {
  constructor(props) {
    super(props);
    this.labelRenderableNode = this.labelRenderableNode.bind(this);
  }

  state = { renderAggregates: true };
  componentWillReceiveProps(nextProps) {
    this.setState({
      renderAggregates: this.props.aggregateBy === nextProps.aggregateBy,
    });
  }

  interpolate(a, b, interpolate) {
    const { trailingTransitionKeys } = this.props;

    if (trailingTransitionKeys) {
      const intermediate = (a, b) => {
        const m = { ...b };
        trailingTransitionKeys.forEach(key => {
          m[key] = a[key];
        });
        m.children =
          m.children &&
          m.children.map((child, i) => intermediate(a.children[i], child));
        return m;
      };

      const m = intermediate(a, b),
        i1 = interpolate(a, m),
        i2 = interpolate(m, b);
      return t => ({
        ...(t < 0.5
          ? i1(d3.easeCubicOut(t * 2))
          : i2(d3.easeCubicIn(t * 2 - 1))),
        key: b.key,
        data: b.data,
      });
    }

    return interpolate(a, b);
  }

  transitionProps = {
    identify: d => `${d.side}-${d.key}`,
    duration: 1000,
    stagger: 3 / 8,
    interpolate: this.interpolate.bind(this),
  };

  labelRenderableNode(node) {
    const tooSmallY = 30;
    const textNoBreak = +(node.y1 - node.y0 < tooSmallY);
    const showLabel = node.y1 - node.y0 > tooSmallY;

    return {
      ...node,
      showLabel,
      textNoBreak,
      textYOffset: showLabel ? 16 : 12,
      labelYOffset: textNoBreak ? 0 : 14,
      labelXOffset: textNoBreak ? Math.max(45, 14*node.key.length) : 5,

      textFadeOut: node.data.values[0].willExit,
      opacity: 1,
      tooltipX: node.side === 'before'
        ? textNoBreak ? 110 : 70
        : textNoBreak ? -107 : -67,
      tooltipY: textNoBreak ? 12 : 16,
      textX: node.side === 'before'
        ? node.x1 - node.x0
        : 0,
      percentageX: 0,
      percentageInsideClass: false,
      percentageInsidePosition: 0,
    };
  }

  render() {
    const {
      nodes,
      swaps,
      aggregateBy,
      colorScale,
      size,
    } = this.props;

    const formatPercentage = d3.format('.1%');

    return (
      <div className="flows">
        <svg width={size[0]} height={size[1]}>

          <Transition
            values={nodes.map(this.labelRenderableNode)}
            enterOrExit={d => ({ ...d, opacity: 0 })}
            interpolate={(a, b, interpolate) => t => ({
              ...interpolate(a, b),
              data: b.data,
              key: b.key,
            })}
            {...this.transitionProps}
          >
            {nodes => {
              const childNodeByKey = {};
              nodes.forEach(({ side, children }) => {
                children.forEach(child => {
                  childNodeByKey[`${side}-${child.key}`] = child;
                });
              });

              const links = swaps.map(({ key, before, after }) => {
                const nodeB = childNodeByKey[`before-${before.key}`];
                const nodeA = childNodeByKey[`after-${after.key}`];
                return {
                    key,
                    before: { 
                      ...nodeB,
                      y1: nodeB.y0 === nodeB.y1 
                        ? nodeB.y1 + (nodeA.y1 - nodeA.y0) 
                        : nodeB.y1, 
                    },
                    after: {
                      ...nodeA,
                      y0: nodeA.y0 === nodeA.y1 ? size[1]: nodeA.y0,
                      y1: nodeA.y0 === nodeA.y1 
                        ? size[1] + (nodeB.y1 - nodeB.y0) 
                        : nodeA.y1,
                    },
                  }
              });

              return (
                <g className={"nodes Flows"}>
                  <Transition
                    values={1}
                    duration={this.transitionProps.duration}
                  >
                    {showFlows =>
                      <Links links={links} colorScale={colorScale} />}
                  </Transition>

                  <Nodes
                    nodes={nodes.filter(node => node.side === 'before')}
                    aggregateBy={aggregateBy}
                    align={'left'}
                    formatPercentage={formatPercentage}
                    color={colorScale('before')}
                    dialogLeavingWTSite={this.props.dialogLeavingWTSite}
                  />
                  <Nodes
                    nodes={nodes.filter(node => node.side === 'after')}
                    aggregateBy={aggregateBy}
                    align={'right'}
                    formatPercentage={formatPercentage}
                    color={colorScale('after')}
                    dialogLeavingWTSite={this.props.dialogLeavingWTSite}
                  />
                </g>
              );
            }}
          </Transition>

        </svg>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Flows/Component.js